'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var responsiveProvider = require('@arrive/responsive-provider');
var ReactDOM = require('react-dom');
var reactSpring = require('react-spring');
var cx = require('classnames');
var Button = require('@arrive/button');
var SVGIcon = require('@arrive/svg-icon');
var ERROR = require('@arrive/ui-icons/duo-tone/ic_error_duo.svg');
var CLOSE = require('@arrive/ui-icons/svg/ic_close.svg');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var SVGIcon__default = /*#__PURE__*/_interopDefaultLegacy(SVGIcon);
var ERROR__default = /*#__PURE__*/_interopDefaultLegacy(ERROR);
var CLOSE__default = /*#__PURE__*/_interopDefaultLegacy(CLOSE);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var styles = {"ethanol":"#fff","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"#303236","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"#0062c0","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"#2b731a","whoaNelly":"#ffedf1","jackknife":"#cb2024","toastContainer":"arrive_Toasts__toastContainer","simpleToast":"arrive_Toasts__simpleToast","ribbonToast":"arrive_Toasts__ribbonToast","ribbonToast__ribbon":"arrive_Toasts__ribbonToast__ribbon","ribbonToast__content":"arrive_Toasts__ribbonToast__content","ribbonToast__footer":"arrive_Toasts__ribbonToast__footer","ribbonToast__icon":"arrive_Toasts__ribbonToast__icon","ribbonToast__neutral":"arrive_Toasts__ribbonToast__neutral","ribbonToast__success":"arrive_Toasts__ribbonToast__success","ribbonToast__warning":"arrive_Toasts__ribbonToast__warning","ribbonToast__title":"arrive_Toasts__ribbonToast__title","errorToast":"arrive_Toasts__errorToast","clickable":"arrive_Toasts__clickable","errorIcon":"arrive_Toasts__errorIcon","errorWrapper":"arrive_Toasts__errorWrapper","errorButton":"arrive_Toasts__errorButton","secondaryErrorText":"arrive_Toasts__secondaryErrorText","progressToast":"arrive_Toasts__progressToast","messageToast":"arrive_Toasts__messageToast","messageSecondContent":"arrive_Toasts__messageSecondContent","messageButton":"arrive_Toasts__messageButton","progressBar":"arrive_Toasts__progressBar","progressIcon":"arrive_Toasts__progressIcon","progressTitle":"arrive_Toasts__progressTitle","progressReadback":"arrive_Toasts__progressReadback","progressContent":"arrive_Toasts__progressContent","bar":"arrive_Toasts__bar"};

var SimpleToast = /*#__PURE__*/React__default["default"].forwardRef(function SimpleToast(_ref, ref) {
  var id = _ref.id,
      removeFromQueue = _ref.removeFromQueue,
      timeout = _ref.timeout,
      content = _ref.content,
      style = _ref.style;
  React.useEffect(function () {
    if (timeout !== null) {
      setTimeout(function () {
        removeFromQueue(id);
      }, timeout);
    }
  }, []); // eslint-disable-line

  return /*#__PURE__*/React__default["default"].createElement(reactSpring.animated.div, {
    style: style
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.simpleToast,
    ref: ref
  }, content));
});

var ErrorToast = /*#__PURE__*/React__default["default"].forwardRef(function ErrorToast(_ref, ref) {
  var id = _ref.id,
      removeFromQueue = _ref.removeFromQueue,
      timeout = _ref.timeout,
      content = _ref.content,
      onErrorClick = _ref.onErrorClick,
      style = _ref.style,
      _ref$errorClickText = _ref.errorClickText,
      errorClickText = _ref$errorClickText === void 0 ? 'See more details...' : _ref$errorClickText,
      secondaryErrorText = _ref.secondaryErrorText;
  React.useEffect(function () {
    if (timeout !== null) {
      setTimeout(function () {
        removeFromQueue(id);
      }, timeout);
    }
  }, []); // eslint-disable-line

  var handleErrorClick = function handleErrorClick() {
    if (timeout === null) {
      removeFromQueue(id);

      if (onErrorClick) {
        onErrorClick();
      }
    }
  };

  return /*#__PURE__*/React__default["default"].createElement(reactSpring.animated.div, {
    style: style
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](styles.errorToast, _defineProperty({}, styles.clickable, timeout === null)),
    ref: ref,
    onClick: handleErrorClick
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.errorWrapper
  }, /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
    svgRef: ERROR__default["default"],
    className: styles.errorIcon
  }), content), secondaryErrorText && /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.secondaryErrorText
  }, secondaryErrorText), onErrorClick && /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    text: true,
    className: styles.errorButton
  }, errorClickText)));
});

var ProgressToast = /*#__PURE__*/React__default["default"].forwardRef(function ProgressToast(_ref, ref) {
  var id = _ref.id,
      removeFromQueue = _ref.removeFromQueue,
      content = _ref.content,
      icon = _ref.icon,
      style = _ref.style,
      progressEvent = _ref.progressEvent,
      totalProgressEvents = _ref.totalProgressEvents;

  var _useState = React.useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      progressCounts = _useState2[0],
      setProgressCounts = _useState2[1];

  var _useState3 = React.useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      percentage = _useState4[0],
      setPercentage = _useState4[1];

  React.useEffect(function () {
    var collectProgressNumbers = function collectProgressNumbers(fileName, percent) {
      setProgressCounts(function (prev) {
        return _objectSpread2(_objectSpread2({}, prev), {}, _defineProperty({}, fileName, percent));
      });
    };

    progressEvent(collectProgressNumbers).then(function () {
      setTimeout(function () {
        // give the toast a chance to show the 100% state
        removeFromQueue(id);
      }, 300);
    }); // only start this on mount
  }, []); // eslint-disable-line

  React.useEffect(function () {
    var percentages = Object.values(progressCounts);
    var totalPercent = percentages.reduce(function (total, next) {
      return total + next;
    }, 0);
    var averagePercentage = Math.round(totalPercent / totalProgressEvents);
    setPercentage(averagePercentage);
  }, [progressCounts, setPercentage, totalProgressEvents]);
  var progressReadback = "".concat(percentage, "% complete...");
  var barStyles = reactSpring.useSpring({
    width: "".concat(percentage, "%")
  });
  return /*#__PURE__*/React__default["default"].createElement(reactSpring.animated.div, {
    style: style
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.progressToast,
    ref: ref
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.progressContent
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.progressTitle
  }, /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
    svgRef: icon,
    className: styles.progressIcon
  }), content), /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.progressReadback
  }, progressReadback)), /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.progressBar
  }, /*#__PURE__*/React__default["default"].createElement(reactSpring.animated.div, {
    className: styles.bar,
    style: barStyles
  }))));
});

var MessageToast = /*#__PURE__*/React__default["default"].forwardRef(function MessageToast(_ref, ref) {
  var id = _ref.id,
      removeFromQueue = _ref.removeFromQueue,
      timeout = _ref.timeout,
      content = _ref.content,
      style = _ref.style,
      secondaryContent = _ref.secondaryContent,
      onActionClick = _ref.onActionClick,
      actionClickText = _ref.actionClickText;
  React.useEffect(function () {
    if (timeout !== null) {
      setTimeout(function () {
        removeFromQueue(id);
      }, timeout);
    }
  }, []); // eslint-disable-line

  var handleActionClick = function handleActionClick() {
    if (timeout === null) {
      removeFromQueue(id);
    }

    if (onActionClick) {
      onActionClick();

      if (timeout !== null) {
        removeFromQueue(id);
      }
    }
  };

  return /*#__PURE__*/React__default["default"].createElement(reactSpring.animated.div, {
    style: style
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](styles.messageToast, _defineProperty({}, styles.clickable, !!onActionClick)),
    ref: ref,
    onClick: handleActionClick
  }, /*#__PURE__*/React__default["default"].createElement("div", null, content), /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.messageSecondContent
  }, secondaryContent), onActionClick && /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    text: true,
    className: styles.messageButton
  }, actionClickText)));
});

var RibbonToast = /*#__PURE__*/React__default["default"].forwardRef(function RibbonToast(_ref, ref) {
  var _cx;

  var id = _ref.id,
      removeFromQueue = _ref.removeFromQueue,
      timeout = _ref.timeout,
      content = _ref.content,
      footer = _ref.footer,
      style = _ref.style,
      _ref$severity = _ref.severity,
      severity = _ref$severity === void 0 ? 'NEUTRAL' : _ref$severity;
  React.useEffect(function () {
    if (timeout !== null) {
      setTimeout(function () {
        removeFromQueue(id);
      }, timeout);
    }
  }, []); // eslint-disable-line

  var onCloseClick = function onCloseClick() {
    return removeFromQueue(id);
  };

  var ribbonClassNames = cx__default["default"](styles.ribbonToast__ribbon, (_cx = {}, _defineProperty(_cx, styles.ribbonToast__neutral, severity === 'NEUTRAL'), _defineProperty(_cx, styles.ribbonToast__success, severity === 'SUCCESS'), _defineProperty(_cx, styles.ribbonToast__warning, severity === 'WARNING'), _cx));
  return /*#__PURE__*/React__default["default"].createElement(reactSpring.animated.div, {
    style: style
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.ribbonToast,
    ref: ref
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: ribbonClassNames
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.ribbonToast__content
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    onClick: onCloseClick
  }, /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
    svgRef: CLOSE__default["default"],
    className: styles.ribbonToast__icon
  })), /*#__PURE__*/React__default["default"].createElement("section", {
    className: styles.ribbonToast__title
  }, content), footer && /*#__PURE__*/React__default["default"].createElement("section", {
    className: styles.ribbonToast__footer
  }, footer))));
});

var DEFAULT_TIMEOUT = 5000; // defaults to 5 sec

var ToastContext = /*#__PURE__*/React.createContext(function () {
  console.error('This component is not inside the ToastProvider');
});
function ToastProvider(_ref) {
  var children = _ref.children,
      _ref$maxToastsPresent = _ref.maxToastsPresent,
      maxToastsPresent = _ref$maxToastsPresent === void 0 ? 2 : _ref$maxToastsPresent,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom-left' : _ref$position,
      offset = _ref.offset;

  var _useState = React.useState(function () {
    return new WeakMap();
  }),
      _useState2 = _slicedToArray(_useState, 1),
      refMap = _useState2[0];

  var _useState3 = React.useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      toastQueue = _useState4[0],
      setToastQueue = _useState4[1];

  var _useState5 = React.useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      displayToasts = _useState6[0],
      setDisplayToasts = _useState6[1];

  var currentMediaTypes = React.useContext(responsiveProvider.MediaQueryContext);
  var placement = offset || currentMediaTypes.xs ? [10, 10] : [20, 20];

  var addToToastQueue = function addToToastQueue(newToast) {
    setToastQueue(function (queue) {
      return [].concat(_toConsumableArray(queue), [newToast]);
    });
  };

  var removeFromQueue = function removeFromQueue(id) {
    setDisplayToasts(function (currentToasts) {
      return currentToasts.filter(function (dT) {
        return dT.id !== id;
      });
    });
  };

  React.useEffect(function () {
    var queueCopy = toastQueue.slice();

    if (queueCopy.length && displayToasts.length < maxToastsPresent) {
      var toast = queueCopy.shift();
      setToastQueue(queueCopy);
      setDisplayToasts(function (currentToasts) {
        return [].concat(_toConsumableArray(currentToasts), [toast]);
      });
    }
  }, [displayToasts, maxToastsPresent, refMap, toastQueue]);
  var transitions = reactSpring.useTransition(displayToasts, function (item) {
    return item.id;
  }, {
    from: {
      opacity: 0,
      height: 0
    },
    enter: function enter(item) {
      return /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return next({
                    opacity: 1,
                    height: refMap.get(item).offsetHeight
                  });

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }();
    },
    leave: function leave() {
      return /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(next) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return next({
                    opacity: 0
                  });

                case 2:
                  _context2.next = 4;
                  return next({
                    height: 0
                  });

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }();
    },
    config: {
      tension: 125,
      friction: 20,
      precision: 0.1
    }
  });
  return /*#__PURE__*/React__default["default"].createElement(ToastContext.Provider, {
    value: addToToastQueue
  }, children, /*#__PURE__*/ReactDOM__default["default"].createPortal( /*#__PURE__*/React__default["default"].createElement("div", {
    style: position === 'bottom-left' ? {
      bottom: placement[0],
      left: placement[1]
    } : {
      top: placement[0],
      right: placement[1]
    },
    className: styles.toastContainer
  }, transitions.map(function (_ref4, index) {
    var key = _ref4.key,
        item = _ref4.item,
        props = _ref4.props;

    if (!item) {
      return null;
    }

    var commonProps = {
      removeFromQueue: removeFromQueue,
      ref: function ref(itemRef) {
        return itemRef && refMap.set(item, itemRef);
      },
      key: item.id ? item.id : "".concat(key, "-").concat(index),
      style: props
    };

    if (item.type === 'simple') {
      return /*#__PURE__*/React__default["default"].createElement(SimpleToast, _extends({}, commonProps, {
        timeout: DEFAULT_TIMEOUT
      }, item));
    }

    if (item.type === 'message') {
      return /*#__PURE__*/React__default["default"].createElement(MessageToast, _extends({}, commonProps, {
        timeout: DEFAULT_TIMEOUT
      }, item));
    }

    if (item.type === 'error') {
      return /*#__PURE__*/React__default["default"].createElement(ErrorToast, _extends({}, commonProps, {
        timeout: item.onErrorClick ? null : DEFAULT_TIMEOUT
      }, item));
    }

    if (item.type === 'progress') {
      return /*#__PURE__*/React__default["default"].createElement(ProgressToast, _extends({}, commonProps, {
        timeout: null
      }, item));
    }

    if (item.type === 'ribbon') {
      return /*#__PURE__*/React__default["default"].createElement(RibbonToast, _extends({}, commonProps, {
        timeout: DEFAULT_TIMEOUT
      }, item));
    }

    return null;
  })), document.getElementById('portalTarget')));
}
ToastProvider.propTypes = {
  children: PropTypes__default["default"].node.isRequired,
  maxToastsPresent: PropTypes__default["default"].number,

  /**
   * used to increase the buffer from the bottom left of the screen.
   * Defaults to [20, 20] on desktop and [10, 10] on mobile
   */
  offset: PropTypes__default["default"].arrayOf(PropTypes__default["default"].number)
};

exports.ToastContext = ToastContext;
exports["default"] = ToastProvider;
